import {
  SnippetElement,
  defineElement,
  onClick,
  query
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-RGTSXKO2.js";

// src/snippets/common-country-accordion/common-country-accordion.ts
var CommonCountryAccordion = class extends SnippetElement {
  constructor() {
    super(...arguments);
    this.isOpen = false;
  }
  toggleButton() {
    if (this.isOpen) {
      this.closeModal();
    } else {
      this.openModal();
    }
  }
  openModal() {
    return __async(this, null, function* () {
      var _a, _b;
      this.isOpen = true;
      (_a = this.accordionButtonIcon) == null ? void 0 : _a.classList.remove("rotate-180");
      (_b = this.accordion) == null ? void 0 : _b.open();
    });
  }
  closeModal() {
    return __async(this, null, function* () {
      var _a, _b;
      this.isOpen = false;
      (_a = this.accordionButtonIcon) == null ? void 0 : _a.classList.add("rotate-180");
      (_b = this.accordion) == null ? void 0 : _b.close();
    });
  }
  onItemClick(elm) {
    var _a;
    this.inputCountryCode.value = (_a = elm.dataset.value) != null ? _a : "";
    if (this.form) {
      this.form.submit();
    } else {
      console.log("failed to submit country form");
    }
  }
};
__decorateClass([
  query("[data-input-country-code]")
], CommonCountryAccordion.prototype, "inputCountryCode", 2);
__decorateClass([
  query("[data-button]")
], CommonCountryAccordion.prototype, "buttons", 2);
__decorateClass([
  query("form")
], CommonCountryAccordion.prototype, "form", 2);
__decorateClass([
  query("[data-accordion-button]")
], CommonCountryAccordion.prototype, "accordionButton", 2);
__decorateClass([
  query("[data-accordion-button-icon]")
], CommonCountryAccordion.prototype, "accordionButtonIcon", 2);
__decorateClass([
  query("[data-accordion]")
], CommonCountryAccordion.prototype, "accordion", 2);
__decorateClass([
  onClick("[data-accordion-button]")
], CommonCountryAccordion.prototype, "toggleButton", 1);
__decorateClass([
  onClick("[data-button]")
], CommonCountryAccordion.prototype, "onItemClick", 1);
CommonCountryAccordion = __decorateClass([
  defineElement("common-country-accordion")
], CommonCountryAccordion);
export {
  CommonCountryAccordion
};
